module.exports = "/_next/static/images/b24e59d9446178d6ebc879109126efdc-apple.svg";